import { makeStyles, shorthands } from '@fluentui/react-components';
import { customTokens } from 'src/utils/theme';

export const useDailyHabitEmptyPlansStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    ...shorthands.padding(customTokens.spacingVerticalL, customTokens.spacingHorizontalL),
    borderRadius: customTokens.borderRadiusMedium,
    ...shorthands.border(customTokens.strokeWidthThin, 'solid', customTokens.colorSubtleBackgroundSelected1),
    backgroundColor: customTokens.colorNeutralBackground1,
    flexWrap: 'wrap',
  },
  containerDesktop: {
    flexDirection: 'row',
  },
  containerMobile: {
    flexDirection: 'column',
  },
  messageContainer: {
    flex: 1,
    paddingLeft: customTokens.spacingHorizontalXXL,
  },
  image: {
    paddingLeft: customTokens.spacingHorizontalXXL,
  },
  imageMobile: {
    maxWidth: '100%',
  },
  textWrapper: {
    ...shorthands.padding(
      customTokens.spacingVerticalL,
      customTokens.spacingHorizontalNone,
      customTokens.spacingVerticalNone,
      customTokens.spacingHorizontalXXL),
  },
  title: {
    fontWeight: customTokens.fontWeightRegular,
    lineHeight: customTokens.lineHeightBase600,
    fontSize: customTokens.fontSizeBase600,
    color: customTokens.colorNeutralForeground1,
    ...shorthands.margin(
      customTokens.spacingVerticalNone,
      customTokens.spacingHorizontalNone,
      customTokens.spacingVerticalNone,
      customTokens.spacingHorizontalNone),
  },
  description: {
    marginTop: customTokens.spacingVerticalNone,
    fontSize: customTokens.fontSizeBase400,
    fontWeight: customTokens.fontWeightRegular,
    lineHeight: customTokens.lineHeightBase400,
    color: customTokens.colorNeutralForeground1,
  },
});
